export function AtomVisual() {
  return (
    <div className="atom-wrapper" aria-hidden="true">
      <div className="atom-orbit atom-orbit--1" />
      <div className="atom-orbit atom-orbit--2" />
      <div className="atom-orbit atom-orbit--3" />
      <div className="electron-track"><div className="electron electron--blue" /></div>
      <div className="electron-track electron-track--r60"><div className="electron electron--purple" /></div>
      <div className="electron-track electron-track--rn60"><div className="electron electron--teal" /></div>
      <div className="nucleus">
        <div className="nucleon proton" style={{ top: "50%", left: "50%" }} />
        <div className="nucleon proton" style={{ top: "25%", left: "50%" }} />
        <div className="nucleon proton" style={{ top: "63%", left: "30%" }} />
        <div className="nucleon neutron" style={{ top: "63%", left: "70%" }} />
        <div className="nucleon neutron" style={{ top: "37%", left: "28%" }} />
        <div className="nucleon neutron" style={{ top: "37%", left: "72%" }} />
        <div className="nucleon neutron" style={{ top: "75%", left: "50%" }} />
        <div className="nucleus-glow" />
      </div>
    </div>
  );
}
